import type { MailboxInfo } from "owa-client-types";
import { UserCohort } from "owa-bizchat-types/lib/UserCohort";
import { getUserCohort } from "owa-sidepane-bizchat-store";

export function isCohortAISKU(mailboxInfo: MailboxInfo): boolean {
    return getUserCohort(mailboxInfo) === UserCohort.BCAIS;
}
